import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { OverlayForm, AppFields } from '../../../store';
import { MyTeamsService } from '../../../services/my-teams.service';
import { HelperService, AlertService } from '../../../services';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-team-players-flyout',
  templateUrl: './team-players-flyout.component.html',
  styleUrls: ['./team-players-flyout.component.css']
})
export class TeamPlayersFlyoutComponent extends OverlayForm implements OnInit {

  public userID;
  public roleID;
  public gaurdianList = [];
  public gaurdianListCounts = 0;

  public clubDetails;

  form: FormGroup;
  teamID = 0;
  @Input() playerData: any;
  @Input() isStaff: boolean;
  @Output() viewFullProfile: EventEmitter<boolean> = new EventEmitter;
  @Output() close: EventEmitter<boolean> = new EventEmitter;
  @Output() refresh: EventEmitter<boolean> = new EventEmitter;
  @Output() mailTo: EventEmitter<any> = new EventEmitter;

  constructor(
    public fb: FormBuilder,
    private service: MyTeamsService,
    private store: Store<any>,
    private loader: Ng4LoadingSpinnerService,
    private helperService: HelperService,
    private alertService: AlertService
  ) {
    super(fb);
    this.store.select(AppFields.App, AppFields.MyTeam).subscribe(team => {
      if (team != null) {
        this.teamID = team.teamID;
      }
    });
    this.getClubDetails();
  }

  ngOnInit() {
    this.userID = +localStorage.getItem('userId');
    this.roleID = +localStorage.getItem('roleId');
    if (!this.isStaff) {
      this.getGaurdianFamilyInfo(this.playerData.userID);
    }

    //console.log("StaffData =>", this.playerData);
  }

  getGaurdianFamilyInfo(playerID) {
    this.loader.show();
    this.service.getGaurdianFamilyInfo(playerID).subscribe((rs) => {
      this.loader.hide();
      this.gaurdianList = [];
      this.gaurdianListCounts = 0;
      if (rs && rs.length > 0) {
        this.gaurdianList = rs;
        this.gaurdianListCounts = rs.length;
      }
    }, (error) => {
      console.log(error.error);
      this.loader.hide();
    });
  }

  cancel() {
    this.close.emit(true);
  }

  onViewFullProfile() {
    this.viewFullProfile.emit(true);
  }

  validatePlayerEmail(player): boolean {
    if (player.email) {
      const emailFormControl = new FormControl(player.email, [
        Validators.required,
        Validators.email // This will validate if the input value is a valid email format
      ]);

      if (emailFormControl.valid) {
        return true;
      } else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  sendLinkToActive(player, e) {
    let isValidEmail: boolean = this.validatePlayerEmail(player);

    if (!isValidEmail) {
      this.alertService.warnHigh("This player does not have valid email address.");
      return;
    }
    this.loader.show();

    const obj = {
      SenderID: this.userID,
      RecipientID: player.userID,
      RecipientEmail: player.email,
      FirstName: player.firstName,
      LastName: player.lastName,
      ClubName: this.clubDetails ? this.clubDetails.name : "",
      ClubImage: this.clubDetails ? this.clubDetails.clublogo : ""
    };

    this.service.sendEmailToPlayerForActive(obj, this.isStaff).subscribe(() => {
      this.cancel();
      this.alertService.success('Activation email has been sent successfully.');
      this.loader.hide();
    }, (error) => {
      console.log(error.error);
      this.alertService.error('Something Went Wrong!');
      this.loader.hide();
    });
  }

  getClubDetails() {
    this.store.select(AppFields.App, AppFields.Club).subscribe(club => {
      this.clubDetails = club;
    });
  }

  formatPhoneNumber(number: string) {
    return this.helperService.formatPhoneNumber(number);
  }

  sendMailToParent(gaurdian) {
    var obj = { userID: gaurdian.parentUserID, email: gaurdian.email };
    this.mailTo.emit(obj);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/team-players-flyout/team-players-flyout.component.ts